<template>
  <div id="app" :class="app_states.state_content_class">
    <Header
      :class="{ sticked: sticky_header }"
      v-bind:has_video="app_states.has_header_video"
      v-on:menu_state_changed="handleMenuStateChanged"
      v-on:reload="handleReloadContent"
      v-bind:client_cart="client_cart"
      v-on:handle_sidebar="handleOpenSidebar"
    />

    <MainVideo
      v-on:open_player="openPlayer"
      v-if="app_states.header_video_url"
      v-bind:video_src="app_states.header_video_url"
      v-bind:video_caption="app_states.header_video_caption"
    />

    <div v-if="content.kind_of_page === 'shoplo'">
      <Product
        v-if="content.product"
        v-bind:product_data="content.product"
        v-on:shoplo_add_product_cart="handleShopAddCart"
      />
      <CategorizedProducts
        v-if="content.categorized_products"
        v-bind:categorized_products_data="content.categorized_products"
      />
    </div>

    <div v-if="content.kind_of_page === 'wp'">
      <router-view
        v-bind:content_text="content.page"
        v-bind:content_text2="content.product"
        v-bind:services="content.services"
        v-bind:next_prev_navigation="next_prev_navigation"
        v-bind:events_collection="collections.events"
        v-on:reload="handleReloadContent"
        v-on:shoplo_add_product_cart="handleShopAddCart"
      />
    </div>

    <ShopBar
      v-on:handle_sidebar="handleCloseSidebar"
      v-bind:update_trigger="cart_updated"
      v-bind:client_cart="client_cart"
      v-on:shoplo_checkout_action="handleCheckout"
      v-on:shoplo_remove_cart="handleShopRemoveCart"
      v-on:shoplo_update_cart="handleShopUpdateCart"
      v-on:close_sidebar="handleCloseSidebar"
      v-on:shop_order="handleShopOrder"
    />

    <Footer v-on:reload="handleReloadContent" />
    <Player
      v-if="app_states.player_video_url"
      v-on:close_player="closePlayer"
      v-on:choose_cursor="chooseCursor"
      v-bind:video_src="app_states.player_video_url"
      v-bind:video_type="app_states.player_video_calling_type"
    />
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Player from "@/components/Player.vue";
import Product from "@/components/Product.vue";
import CategorizedProducts from "@/components/CategorizedProducts.vue";
import Footer from "@/components/Footer.vue";
import MainVideo from "@/components/MainVideo.vue";
import ShopBar from "@/components/ShopBar.vue";

const API = window.APP_INFO.init.REST_PREFIX + "/wp-json/wp/v2";
const SHOPLO_API = window.APP_INFO.init.REST_PREFIX + "/wp-json/shoplo/v1";

let MouseX = 0;
let MouseY = -100;
let minCursorStep = 10;
let maxMoveSteps = 3;

let cursorDefX = 0;
let cursorDefY = 0;

let defCursorPosition = null;
let $sensitiveElement = null;
let $lastCursorType = null;

let $sensitiveElement2 = null;
let relCur = null;

function updateCursorRelativePosition() {
    //console.log('updateCursorRelativePosition')
    if ($sensitiveElement2 == null) {
        relCur.style.opacity = "0";
        relCur.style.transition = "opacity 0.5s";
        return;
    } else {
        if (MouseY > 0) {
            relCur.style.opacity = "1";
        }
    }

    let rect = $sensitiveElement2.getBoundingClientRect();
    let relX = MouseX - rect.left; //x position within the element.
    let relY = MouseY - rect.top;  //y position within the element.
    //console.log("Left? : " + x + " ; Top? : " + y + ".");

    let lastCursX = parseInt(relCur.style.left, 10);
    let lastCursY = parseInt(relCur.style.top, 10);

    let distanceX = lastCursX - relX;
    let distanceY = lastCursY - relY;

    if (distanceX < 0) {
        distanceX *= -1;
    }
    //console.log('d' + distanceX);
    if (distanceY < 0) {
        distanceY *= -1;
    }

    let stepX = distanceX / maxMoveSteps;
    let stepY = distanceY / maxMoveSteps;

    //console.log('stepX amount ' + stepX);
    /*if (Math.abs(stepX) < minCursorStep) {
        stepX = minCursorStep;
    }

    if (Math.abs(stepY) < minCursorStep) {
        stepY = minCursorStep;
    }*/

    if (Math.abs(distanceX) > Math.abs(distanceY)) {
        stepY = distanceY / (distanceX / stepX);
    } else {
        stepX = distanceX / (distanceY / stepY);
    }

    if (lastCursX < relX) {
        if (relX - stepX >= lastCursX) {
            lastCursX = (relX - stepX);
            relCur.style.left = lastCursX + "px";
        } else {
            lastCursX = relX;
            relCur.style.left = lastCursX + "px";
        }
    } else {
        if (relX + stepX <= lastCursX) {
            lastCursX = (relX + stepX);
            relCur.style.left = lastCursX + "px";
        } else {
            lastCursX = relX;
            relCur.style.left = lastCursX + "px";
        }
    }

    if (lastCursY < relY) {
        if (relY - stepY >= lastCursY) {
            relCur.style.top = (relY - stepY) + "px";
        } else {
            relCur.style.top = relY + "px";
        }
    } else {
        if (relY + stepY <= lastCursY) {
            relCur.style.top = (relY + stepY) + "px";
        } else {
            relCur.style.top = relY + "px";
        }
    }
}

function catchCursorPosition(element) {
  let x = parseInt(cursor.offsetLeft, 10);
  let y = parseInt(cursor.offsetTop, 10);

  let currentX = 0;
  let currentY = 0;

  if ($sensitiveElement == null) {
    cursor.style.opacity = "0";
    cursor.style.transition = "opacity 0.5s, width 0.5s, height 0.5s";
    if (false && defCursorPosition != null) {
      let cords = JSON.parse(defCursorPosition);
      //console.log(defCursorPosition);
      console.log(cords);
      cursor.style.opacity = "0";
      cursor.style.transition = "opacity 0.5s, width 0.5s, height 0.5s";
      // currentX = cords.left;
      //currentY = cords.top;
      return;
    } else {
      return;
    }
  } else {
    currentX = MouseX;
    currentY = MouseY;
    if (MouseY > 0) {
      cursor.style.opacity = "1";
    }
  }

  let distanceX = currentX - x;
  let distanceY = currentY - y;
  if (distanceX < 0) {
    distanceX *= -1;
  }
  //console.log('d' + distanceX);
  if (distanceY < 0) {
    distanceY *= -1;
  }

  let stepX = distanceX / maxMoveSteps;
  let stepY = distanceY / maxMoveSteps;

  if (Math.abs(stepX) < minCursorStep) {
    stepX = minCursorStep;
  }

  if (Math.abs(stepY) < minCursorStep) {
    stepY = minCursorStep;
  }

  if (Math.abs(distanceX) > Math.abs(distanceY)) {
    stepY = distanceY / (distanceX / stepX);
  } else {
    stepX = distanceX / (distanceY / stepY);
  }

  if (currentX < x) {
    if (x - stepX >= currentX) {
      cursor.style.left = x - stepX + "px";
    } else {
      cursor.style.left = currentX + "px";
    }
  } else {
    //console.log(x, stepX)
    if (x + stepX <= currentX) {
      cursor.style.left = x + stepX + "px";
    } else {
      cursor.style.left = currentX + "px";
    }
  }
  /*
    if (x + stepX <= MouseX) {
        cursor.style.left = (x + stepX) + 'px'
    } else {
        cursor.style.left = (MouseX) + 'px'
    }*/

  if (currentY < y) {
    if (y - stepY >= currentY) {
      cursor.style.top = y - stepY + "px";
    } else {
      cursor.style.top = currentY + "px";
    }
  } else {
    if (y + stepY <= currentY) {
      cursor.style.top = y + stepY + "px";
    } else {
      cursor.style.top = currentY + "px";
    }
  }
}

let $scroll_sensitive_elements = null;

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Product,
    CategorizedProducts,
    Player,
    ShopBar,
    MainVideo,
  },
  data() {
    return {
      page_type: window.APP_INFO.init.page_type,
      sticky_header: false,
      app_states: {
        state_content_class: [
          "none",
          "",
          window.APP_INFO.init.page_type,
          window.APP_INFO.init.template,
        ],
        has_header_video: false,
        header_video_url: "",
        header_video_caption: "",
        player_video_url: "",
        player_video_calling_type: null,
      },
      content: {
        title: window.APP_INFO.init.title,
        kind_of_page: window.APP_INFO.init.kind_of_page,
        page: window.APP_INFO.init.content, // html
        product: window.APP_INFO.init.product, // json
        categorized_products: window.APP_INFO.init.categorized_products, // json
        services: [],
        template: window.APP_INFO.init.template,
      },
      cart_updated: 0,
      client_cart: window.APP_INFO.init.client_cart,
      collections: {
        events: [],
      },
      next_prev_navigation: window.APP_INFO.init.next_prev_navigation,
    };
  },
  methods: {
    chooseCursor(cursor_type) {
      cursor.classList.remove('normal')
      cursor.classList.remove('close')
      cursor.classList.add(cursor_type);
    },
    openPlayer(src, type) {
      //console.log(document.getElementById('player'))
      //console.log("player open for " + src);
      this.app_states.player_video_calling_type = type ? type : 'main-video';
      this.app_states.player_video_url = src;
    },
    closePlayer() {
      this.app_states.player_video_url = "";
    },
    handleCheckout(e) {
      axios.get(`${SHOPLO_API}/checkout`).then(function (response) {
        console.log(response);
        if (response.data.checkout_url != null) {
          window.location = response.data.checkout_url;
        }
      });
    },
    handleShopAddCart(e) {
      console.log("add shoplo cart");
      const vm = this;

      axios
        .put(`${SHOPLO_API}/cart`, {
          variant_id: e.variant_id,
          quantity: e.quantity,
        })
        .then(function (response) {
          console.log("after add");
          console.log(response.data);
          if (response.data.state === "success") {
            console.log("sucecs");
            let i;
            let is_updated = false;
            //let total_price = 0;
            for (i = 0; i < vm.client_cart.length; i++) {
              //console.log(vm.client_cart[i].variant_id);

              if (
                vm.client_cart[i].variant_id ==
                response.data.cart_data.variant_id
              ) {
                let current_cart = vm.client_cart;
                //let current_cart = vm.client_cart[i];
                console.log(current_cart[i].quantity);
                current_cart[i].quantity = response.data.cart_data.quantity;
                console.log("update quantity");

                //vm.client_cart[i] = current_cart;
                //vm.client_cart = null;
                //vm.cart_updated = 10;
                vm.client_cart = current_cart.slice();
                console.log(vm.client_cart[i]);
                //vm.$set(vm.client_cart, i, current_cart)
                is_updated = true;
                break;
              }
              //total_price += parseInt(this.client_cart[i]['price'], 10) * parseInt(this.client_cart[i]['quantity'], 10);
            }

            if (!is_updated) {
              // the product is not in carts set yet
              console.log("add new");
              //console.log(response.data.cart_data)
              let current_cart = vm.client_cart;
              current_cart[vm.client_cart.length] = response.data.cart_data;
              vm.client_cart = current_cart.slice();
              //vm.client_cart[vm.client_cart.length] = response.data.cart_data;
            }
          }
        });
    },
    handleShopRemoveCart(e) {
      const vm = this;
      axios
        .delete(`${SHOPLO_API}/cart`, { data: { cart_id: e.cart_id } })
        .then(function (response) {
          //console.log(response.data);
          let i;
          for (i = 0; i < vm.client_cart.length; i++) {
            if (vm.client_cart[i].id == response.data.cart_data.cart_id) {
              let current_cart = vm.client_cart;
              current_cart.splice(i, 1);
              vm.client_cart = current_cart.slice();
            }
          }
        });
    },
    handleShopUpdateCart(e) {
      console.log("update shoplo");
      console.log(e);
      axios
        .put(`${SHOPLO_API}/cart`, { cart_id: e.cart_id, quantity: e.quantity })
        .then(function (response) {
          //console.log(response);
        });
    },
    handleMenuStateChanged(e) {
      console.log(e);
      this.app_states.state_content_class = [
        this.app_states.state_content_class[0],
        this.app_states.state_content_class[1] === "" ||
        this.app_states.state_content_class[1] == null
          ? "menu-opened"
          : "",
        this.app_states.state_content_class[2],
        this.app_states.state_content_class[3],
      ];
    },
    handleOpenSidebar(e) {
      this.app_states.state_content_class = [
        this.app_states.state_content_class[0],
        "sidebar-opened", // menu or sidebar state
        this.app_states.state_content_class[2],
        this.app_states.state_content_class[3],
      ];
    },
    handleCloseSidebar(e) {
      this.app_states.state_content_class = [
        this.app_states.state_content_class[0],
        "", // menu or sidebar state
        this.app_states.state_content_class[2],
        this.app_states.state_content_class[3],
      ];
    },
    handleReloadContent(page_data) {
      const vm = this;

      //vm.stopGlobalCursorAnimation();
      vm.stopCursorsAnimation();
      //console.log(page_data);

      let ENDPOINT_URL = API;
      if (page_data.type === "products" || page_data.type === "categories") {
        ENDPOINT_URL = SHOPLO_API;
        console.log(page_data);
      }

      axios
        .get(`${ENDPOINT_URL}/${page_data.type}/${page_data.id}`)
        .then(function (response) {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          vm.sticky_header = false;
          $scroll_sensitive_elements = null;
          if (page_data.type === "pages") {
            vm.content.kind_of_page = "wp";
            vm.content.product = "";
            vm.content.categorized_products = "";
            vm.content.page = response.data.modify_content.lazy;
            vm.content.services = response.data.services;
            console.log(response);
            if (response.data.modify_content.has_video === true) {
              document
                .getElementsByTagName("BODY")[0]
                .setAttribute(
                  "class",
                  "video-page " + response.data.template_classes
                );
            } else {
              document
                .getElementsByTagName("BODY")[0]
                .setAttribute(
                  "class",
                  "normal-page " + response.data.template_classes
                );
            }
          } else if (page_data.type === "event") {
            document
              .getElementsByTagName("BODY")[0]
              .setAttribute("class", "normal-page");
            vm.collections.events = response.data;
            vm.content.kind_of_page = "wp";
            vm.content.product = "";
            vm.content.categorized_products = "";
          } else if (page_data.type === "products") {
            // shoplo api
            vm.content.categorized_products = "";
            document
              .getElementsByTagName("BODY")[0]
              .setAttribute("class", "normal-page");
            console.log(page_data);
            console.log(response.data);
            vm.content.product = response.data[0];
            response.data.template_classes = "";
            response.data.template = "products";
            vm.content.kind_of_page = "shoplo";
            console.log("link" + page_data.href);
            vm.shoploPushHistoryState("products", page_data.href);
            vm.showVideo("");
          } else if (page_data.type === "categories") {
            // shoplo api

            document
              .getElementsByTagName("BODY")[0]
              .setAttribute("class", "normal-page");
            vm.showVideo("");
            vm.content.product = "";
            vm.content.kind_of_page = "shoplo";
            vm.content.categorized_products = response.data;

            response.data.template = "categorized-products";

            vm.shoploPushHistoryState("shop", page_data.href.value);
          }
          vm.content.template = page_data.type;
          console.log("response template " + response.data.template);
          vm.app_states.state_content_class[2] = page_data.type;
          vm.app_states.state_content_class[3] = response.data.template_classes;

          vm.page_type = page_data.type;

          if (response.data.modify_content != null) {
            vm.showVideo(response.data.modify_content.lazy);
          }

          vm.runCursorsAnimation();

          vm.app_states.state_content_class = [
            vm.app_states.state_content_class[0],
            "",
            vm.app_states.state_content_class[2],
            vm.app_states.state_content_class[3],
          ];
        })
        .catch(function (error) {
          console.log(error);
          vm.app_states.state_content_class = [
            vm.app_states.state_content_class[0],
            "",
            vm.app_states.state_content_class[2],
            vm.app_states.state_content_class[3],
          ];
        });
    },
    shoploPushHistoryState(title, url) {
      console.log(window.history, title, url);
      window.history.pushState({ title, url }, title, url);
    },
    shoploGoBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    cursorRelativePosition() {
    //console.log('cursorRelativePosition')
        let vm = this;
        let $sensitives = document.querySelectorAll(".cursor-sensitive");
    //console.log($sensitives)
        for (let i = 0; i < $sensitives.length; ++i) {

            $sensitives[i].onmouseover = function (e) {
            //console.log('mouse over', e.currentTarget.getBoundingClientRect())

                relCur = e.currentTarget.querySelector('.inner-cursor');
                $sensitiveElement2 = e.currentTarget;
                console.log('mouse over (element)', $sensitiveElement2.getBoundingClientRect())
                console.log($sensitiveElement2)

                // *** this is copied code from old cursor version - start

                let _defCursorPosition = e.target.getAttribute("data-cursor-default");
                if (_defCursorPosition != null) {
                    defCursorPosition = _defCursorPosition;
                }
                //console.log(defCursorPosition)
                //if(e.target.getAttribute('data-cursor-default'))
                $sensitiveElement = $sensitives[i];
                if($sensitives[i].classList.contains('cursor-gallery')) {
                    cursor.classList.add('cursor-gallery')
                } else {
                    cursor.classList.remove('cursor-gallery')
                }
                $sensitives[i].style.borderColor = "red";

                // *** this is copied code from old cursor version - end
            }
            /*$sensitives[i].onmouseout = function (e) {
                console.log('mouse out', e.target)
            }*/
        }
    },
    mouseOverListen() {
      let vm = this;
      let $sensitives = document.querySelectorAll(".cursor-sensitive");
      let $blockers = document.querySelectorAll(".mouse-blocker");
      //console.log('mouseOverListen');
      // console.log($sensitives.length);
      for (let i = 0; i < $sensitives.length; ++i) {
        //console.log($sensitives[i])
        $sensitives[i].onmouseover = function (e) {
          //console.log(e.target);
          let _defCursorPosition = e.target.getAttribute("data-cursor-default");
          if (_defCursorPosition != null) {
            defCursorPosition = _defCursorPosition;
          }
          //console.log(defCursorPosition)
          //if(e.target.getAttribute('data-cursor-default'))
          $sensitiveElement = $sensitives[i];
          if($sensitives[i].classList.contains('cursor-gallery')) {
            cursor.classList.add('cursor-gallery')
          } else {
            cursor.classList.remove('cursor-gallery')
          }
          $sensitives[i].style.borderColor = "red";
          //e.stopPropagation();
        };
        $sensitives[i].onmouseout = function (e) {
          //console.log(e)
          //console.log(vm.app_states.player_video_url)
          if (vm.app_states.player_video_url == "") {
            $sensitiveElement = null;
          }

          $sensitives[i].style.borderColor = "green";
        };
      }
      for (let i = 0; i < $blockers.length; ++i) {
        // console.log($sensitives[i])
        $blockers[i].onmouseover = function (e) {
          //console.log(e)
          $blockers[i].style.borderColor = "blue";
          e.stopPropagation();
          $sensitiveElement = null;
          $sensitiveElement2 = null;
        };
        $blockers[i].onmouseout = function (e) {
          //console.log(e)
          //$sensitives[i].style.borderColor = 'green';
        };
      }
    },
    showVideo(content) {
      const vm = this;
      vm.app_states.has_header_video = false;

      if (content.indexOf("lazy-video-") > 0) {
        let matches = content.match(/data-lazy-src="([^"]+)"/);
        if (matches[1] != null) {
          vm.app_states.header_video_url = matches[1];
        }
        //console.log(matches)
        //console.log(vm.page_type)
        if (vm.page_type != "collection") {
          let matchesDesc = content.match(/data-desc="([^"]+)"/);
          if (matchesDesc[1] != null) {
            vm.app_states.header_video_caption = decodeHTMLEntities(
              matchesDesc[1]
            );
          }
        } else {
          vm.app_states.header_video_caption =
            '<h1 class="collection-title">' + vm.content.title + "</h1>";
        }

        vm.hideVideoMask();
      } else {
        console.log("has no video");
        vm.app_states.header_video_url = "";
        //this.app_states.has_header_video = false;
      }
    },
    bindCoverVideo(){
        const vm = this;
        let $videos = document.querySelectorAll(".cover-video");
        let src = 'http://pacuraco.local/wp-content/uploads/2020/11/sample-1mb.mp4';
        for (let i = 0; i < $videos.length; ++i) {
            let video_src = $videos[i].getAttribute('data-video-src');
            if(video_src != null) {
                $videos[i].addEventListener('click', function() {
                    vm.openPlayer(video_src, 'cover-video')
                });
            }
        }
    },
    hideVideoMask() {
      let $cursor_mask;
      if (($cursor_mask = document.getElementById("cursor-mask")) != null) {
        console.log("hide video mask");
        $cursor_mask.style.height = "0px";
      } else {
        let vm = this;
        setTimeout(function () {
          vm.hideVideoMask();
        }, 600);
      }
    },
    runCursorsAnimation() {
        //console.log('cursors running')
        const $cursors = document.querySelectorAll('.cursor');
    //console.log($cursors);
        for (let i = 0; i < $cursors.length; ++i) {
            //$cursors[i].classList.remove('cursor--run')
            //$cursors[i].offsetWidth;
            //$cursors[i].style.transform = ' translate(-50%, -50%)';
            $cursors[i].classList.add('cursor--run')
        }
    },
    stopCursorsAnimation() {
        console.log('global cursor stop')
        const $cursors = document.querySelectorAll('.cursor');
        for (let i = 0; i < $cursors.length; ++i) {
            $cursors[i].classList.remove('cursor--run')
            $cursors[i].offsetWidth;
        }
        //$cursor.classList.remove('cursor--run')
        //$cursor.style.transform = 'rotate(0deg) translate(-50%, -50%)';
    //console.log($cursor)
    },
  },
  created() {
    const vm = this;
    //vm.showVideo(vm.content.page)
    //console.log(this.content.page)

    let cursor = document.getElementById("cursor");

    let show = document.getElementById("show");
    let socials = document.getElementById("socials");
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;

    let pickUpPoint = 0;
    //console.log(windowHeight)
    let i;
    let top = 0;

    window.onscroll = throttle(function () {
      //window.onscroll = function () {
      if ($scroll_sensitive_elements === null) {
        console.log("i should find elements");
        let $blocks = document.querySelectorAll(".wp-block-columns, .main-gallery, .collage");
        let $socials = document.getElementById("socials");

        if ($blocks.length > 0 || $socials != null) {
          $scroll_sensitive_elements = [];
        }

        if ($blocks.length > 0) {
          $scroll_sensitive_elements["blocks"] = [];
          //$scroll_sensitive_elements['blocks']['cont'] = $blocks;
          for (i = 0; i < $blocks.length; ++i) {
            $scroll_sensitive_elements["blocks"][i] = [];
            $scroll_sensitive_elements["blocks"][i]["cont"] = $blocks[i];
            $scroll_sensitive_elements["blocks"][i]["covers"] = $blocks[
                    i
                    ].querySelectorAll(".cover");
            $scroll_sensitive_elements["blocks"][i]["items"] = $blocks[
              i
            ].querySelectorAll(".blocks-gallery-item figure, .cover, .image-block .wp-block-image");
          }
        }

        if ($socials != null && windowWidth > 1200) {
          $scroll_sensitive_elements["socials"] = $socials;
          $scroll_sensitive_elements["socials_rel"] = $socials.querySelectorAll(
            ".relative"
          )[0];
          $scroll_sensitive_elements[
            "socials_layers"
          ] = $socials.querySelectorAll(".layer");
          $scroll_sensitive_elements["socials"].classList.add("is-animated");
        }
      } else {
        let docScrTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (docScrTop > 20) {
          vm.sticky_header = true;
        } else {
          vm.sticky_header = false;
        }

        if ($scroll_sensitive_elements["socials"] != null) {
          pickUpPoint =
            $scroll_sensitive_elements["socials"].offsetTop +
            3500 -
            $scroll_sensitive_elements["socials_layers"][6].offsetHeight;

          if (docScrTop >= $scroll_sensitive_elements["socials"].offsetTop) {
            $scroll_sensitive_elements["socials"].classList.add(
              "animate-tiles"
            );

            let distance_factor =
              docScrTop - $scroll_sensitive_elements["socials"].offsetTop;

            let layers = $scroll_sensitive_elements["socials_layers"];
            for (i = 0; i < layers.length; ++i) {
              //layers[i].style.position = 'fixed';
              //layers[i].classList.add('active');
              let scale = layers[i].getAttribute("data-scale");
              let delay = parseInt(layers[i].getAttribute("data-speed"), 10);
              if (delay > distance_factor) {
                //layers[i].style.transform = 'scale('+ scale +')';
                continue;
              }
              //distance -= speed;
              //console.log('sc ' + scale);
              scale -= (distance_factor - delay) / 480;
              if (scale < 0.8) {
                scale = 0.8;
              }
              layers[i].style.transform = "scale(" + scale + ")";
            }

            if (docScrTop > pickUpPoint) {
              $scroll_sensitive_elements["socials"].classList.add(
                "animation-end"
              );
              $scroll_sensitive_elements["socials_rel"].style.top =
                "-" + (docScrTop - pickUpPoint) + "px";
              //$scroll_sensitive_elements['socials'].style.backgroundColor = 'red';
            } else {
              $scroll_sensitive_elements["socials"].classList.remove(
                "animation-end"
              );
              $scroll_sensitive_elements["socials_rel"].style.top = top;
              //console.log(rel[0].style.top);
              //$scroll_sensitive_elements['socials'].style.backgroundColor = 'yellow';
            }
          } else {
            //before is scrolled to socials gallery
            //top = ($scroll_sensitive_elements['socials'].offsetTop - docScrTop);
            top =
              (docScrTop - $scroll_sensitive_elements["socials"].offsetTop) / 3;
            //console.log(top)
            $scroll_sensitive_elements["socials_layers"][2].style.transform =
              "scale(4.5)";
            $scroll_sensitive_elements["socials_rel"].style.top = top + "px";
            $scroll_sensitive_elements["socials"].classList.remove(
              "animate-tiles"
            );
            $scroll_sensitive_elements["socials"].classList.remove(
              "animation-end"
            );
          }
        }

        if ($scroll_sensitive_elements["blocks"] != null) {
          //show.innerHTML = document.documentElement.scrollTop;

          for (i = 0; i < $scroll_sensitive_elements["blocks"].length; ++i) {

            let $block = $scroll_sensitive_elements["blocks"][i]["cont"];
            let bot = $block.offsetTop;
            //let bob = $block.offsetTop + $block.offsetHeight;
            /*if (bot < docScrTop + windowHeight - 20) {
               $block.style.borderTop = '1px solid green';
            }*/

              if (bot < docScrTop + (windowHeight * .5) - 20) {
                  $block.classList.add('active');
              }

            /*if (bob < docScrTop + 20) {
               $block.style.borderBottom = '1px solid red';
            }*/

            if (
              bot < docScrTop + windowHeight - 20 &&
              $block.offsetTop + $block.offsetHeight > docScrTop + 20
            ) { // is actual on screen
              //$block.style.backgroundColor= 'yellow';

              let img = $scroll_sensitive_elements["blocks"][i]["items"];
              if (img[0] != null) {
                let val =
                  (docScrTop - (bot - windowHeight)) /
                  (windowHeight + $block.offsetHeight);
                let factor = val;
                let factor1 = val * 120 - 60;
                /*if (val * 1.8 <= 1) {
                                    img[1].style.opacity = val * 1.8;
                                } else {
                                    img[1].style.opacity = 1;
                                }*/
                //console.log(factor);
                  img[0].style.transform =
                          "scale("+ (1+(factor/10)) +") matrix(1, 0, 0, 1, 0, " + factor1 + ")";

                  if (img[1] != null) {
                img[1].style.transform =
                  "matrix(1, 0, 0, 1, 0, " + factor1 + ")";
                  }

                  if (img[2] != null) {
                      img[2].style.transform =
                              "scale("+ (1+(factor/10)) +") matrix(1, 0, 0, 1, 0, " + factor1 + ")";
                  }

                  if (img[3] != null) {
                      img[3].style.transform =
                              "matrix(1, 0, 0, 1, 0, " + factor1 + ")";
                  }
                //let figure = img[1].querySelector('figure');
                // figure.style.backgroundSize = (130 - val/10) + '%';
              }
            } else {
              //$block.style.backgroundColor= 'transparent';
            }
          }
        }
      }
      //};
    }, 10);
    /*
        window.onscroll = debounce(function () {
            let docScrTop = document.body.scrollTop || document.documentElement.scrollTop;
            if (docScrTop < 10) {
                vm.sticky_header = false;

            }
            console.log('debounce ' + docScrTop)
        }, 1000); */

    setInterval(function () {
      updateCursorRelativePosition();
      catchCursorPosition(cursor);
    }, 20);

    window.addEventListener("mousemove", function (e) {
      //console.log(e);
      vm.mouseOverListen();
      vm.cursorRelativePosition(); // psuje kursor
      //updateCursorRelativePosition();
      //console.log(e.clientX);

      MouseX = e.clientX;
      MouseY = e.clientY;
    });

    window.onpopstate = function () {
      if (vm.$router.history.current.path === "/") {
        window.location.href = "/";
        return;
      }
      console.log("current path: " + vm.$router.history.current.path);
      window.location = vm.$router.history.current.path;
      /*for (let i = 0, l = APP_INFO.menu_links.length; i<l; i++) {
                if (APP_INFO.menu_links[i].url === vm.$router.history.current.path) {
                    vm.handleReloadContent({
                        href: APP_INFO.menu_links[i].url,
                        id: APP_INFO.menu_links[i].page_id
                    });
                    break;
                }
            }*/
    };
  },
  mounted() {
    const vm = this;
    vm.cursorRelativePosition(); // psuje kursor

    //return;
    // console.log('mounted main');
    setTimeout(function () {
      if (document.documentElement.scrollTop < 50) {

        vm.mouseOverListen();
        vm.hideVideoMask();
      }
    }, 600);
    //console.log(vm.content.page)
    if (vm.content.kind_of_page != "shoplo") {
      vm.showVideo(vm.content.page);
    }
  },
  updated() {
    //console.log('updated')
    const vm = this;
    vm.runCursorsAnimation();
    vm.bindCoverVideo();
  },
};
</script>

<style lang="scss">
@import "./scss/main.scss";

$light-text: #ffffff;
$dark-text: #02317f;

#show {
  position: fixed;
  top: 10px;
  left: 10px;
  background-color: #fff;
  padding: 3px;
  z-index: 100000;
  display: none;
}

#cursor {
  border-radius: 50%;
  width: 150px;
  height: 150px;
  opacity: 0;
  position: fixed;
  top: -100px;
  left: 0;
  z-index: 10000;
  transform: translate(-50%, -50%);
  pointer-events: none;
  text-rendering: optimizeSpeed;
  transition: opacity 1s, width 0.5s, height 0.5s;

  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &.cursor-gallery:after {
    background-image: url("assets/icons/open-gallery.svg");
  }
}

#app {
  font-family: "Roboto", sans-serif;
  //background-color: $body-main;
  overflow-x: hidden;
}
</style>
